/**
 * formatSex — THE ONE DISPLAY FORMATTER FOR A STORED sex / gender VALUE.
 *
 * ═══ WHY THIS IS A DISPLAY FORMATTER AND NOT A DATA MIGRATION ═══
 * The stored value is lowercase BY DESIGN and has to stay that way:
 *   · utils/patientMatch.js normalizeSex() compares on the LOWERCASE form, and
 *     the demographics-match chip is wired to that comparison;
 *   · orella-patient-app OnboardingIdentity.jsx writes 'male' / 'female' /
 *     'other' at intake;
 *   · PatientHeaderCard.jsx's <option value="male">Male</option> already proves
 *     the split — the LABEL is capitalised, the VALUE is not, and it is the
 *     value that every other surface prints.
 * Re-casing what is stored would silently break the match. The capitalisation
 * therefore happens at the point of RENDER, and nowhere else.
 *
 * Returns '' for an absent value, so a caller's own `|| 'N/A'` still fires.
 * An unrecognised value is title-cased rather than dropped — a renderer's job is
 * to display what is stored, not to validate it.
 *
 * ★ Do not mint a second one of these.
 *
 * ★★★ THIS IS A COPY. `orella-md-panel` and `orella-patient-app` are separate
 *     git roots with no shared package, so this file EXISTS TWICE ON PURPOSE
 *     (SEX-CAPITALISE-SWEEP-2). Change one, change the other. The two must not
 *     drift: the panel's demographics-match chip compares the LOWERCASE stored
 *     value, and this app is where that value is written at intake.
 */
export const formatSex = (value) => {
  if (value == null) return ''
  const s = String(value).trim()
  if (!s) return ''
  const lower = s.toLowerCase()
  // single-letter forms are stored by the card scanner and some EDI paths
  if (lower === 'm') return 'Male'
  if (lower === 'f') return 'Female'
  return s.replace(/\b[a-z]/g, (c) => c.toUpperCase())
}

export default formatSex
